import type { SeverityLevel } from "@sentry/react";

export enum FrontendErrorCategory {
  ApiError = "api_error",
  RenderError = "render_error",
  NetworkError = "network_error",
  ChunkLoadError = "chunk_load_error",
  Unknown = "unknown",
}

/**
 * Sentry severity levels mapped to operational severity tiers
 * (mirrors backend convention):
 *   fatal   = Sev1 -> app unusable (chunk load failure, critical network outage)
 *   error   = Sev2 -> feature broken (5xx, unhandled exception)
 *   warning = Sev3 -> low-impact edge case
 */
export type SentryLevel = Extract<SeverityLevel, "fatal" | "error" | "warning">;

export interface SentryEventContext {
  errorCategory: FrontendErrorCategory;
  errorType?: string;
  level: SentryLevel;

  route?: string;
  component?: string;

  httpMethod?: string;
  httpUrl?: string;
  httpStatusCode?: number;
  correlationId?: string;
  apiType?: "rest" | "graphql";
}
